export type DialogKind = 'Information' | 'Warning' | 'Error' | 'Question';
export type DialogMode = 'OK' | 'YesNo' | 'YesNoCancel' | 'OKCancel';
export type DialogAnswer = 'ok' | 'yes' | 'no' | 'cancel';

export interface AppDialogOptions {
  text: string;
  kind?: DialogKind;
  mode?: DialogMode;
}

export interface AppDialogRequest extends AppDialogOptions {
  kind: DialogKind;
  mode: DialogMode;
}

export function resolveDialogDefaults(
  opts: AppDialogOptions,
): AppDialogRequest {
  const mode = opts.mode ?? 'OK';
  const kind =
    opts.kind ??
    (mode === 'OK' || mode === 'OKCancel' ? 'Information' : 'Question');

  return {
    text: opts.text,
    kind,
    mode,
  };
}

export function dismissAnswerForMode(mode: DialogMode): DialogAnswer {
  switch (mode) {
    case 'OK':
      return 'ok';
    case 'YesNo':
      return 'no';
    case 'YesNoCancel':
    case 'OKCancel':
      return 'cancel';
    default: {
      const _exhaustive: never = mode;
      return _exhaustive;
    }
  }
}
